import React from 'react';
import { CTAButton } from './CTAButton';
import { ShieldCheck, Check } from 'lucide-react';
export function PricingSection() {
  return <section id="compra" className="py-8 px-4 bg-gradient-to-b from-amber-50/60 to-purple-50/40" data-id="element-132">
      <div className="max-w-3xl mx-auto" data-id="element-133">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border-4 border-yellow-400 relative" data-id="element-134">
          {/* Badge */}
          <div className="absolute top-0 right-0 bg-yellow-400 text-black font-bold px-6 py-2 rounded-bl-xl z-10" data-id="element-135">
            50% OFF
          </div>

          <div className="p-6 md:p-8 text-center" data-id="element-136">
            <p className="text-gray-500 font-bold uppercase tracking-widest mb-2" data-id="element-137">
              VALOR REAL DEL PACK{' '}
              <span className="line-through text-red-500" data-id="element-138">$49.990</span>
            </p>

            <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-1" data-id="element-139">
              🌟 OFERTA ESPECIAL DE LANZAMIENTO
            </h2>

            <p className="text-xl text-gray-600 mb-4" data-id="element-140">
              Hoy podés llevar CREANDO RECUERDOS REALES + los 3 BONOS + acceso
              de por vida
            </p>

            <div className="bg-gray-50 p-4 rounded-xl mb-4 inline-block w-full max-w-md mx-auto border border-gray-200" data-id="element-141">
              <p className="text-red-600 font-bold mb-1" data-id="element-142">🔥 HOY SOLO:</p>
              <div className="flex items-center justify-center gap-2 mb-1" data-id="element-143">
                <span className="text-2xl text-gray-400 font-medium" data-id="element-144">ARS</span>
                <span className="text-6xl font-black text-gray-900" data-id="element-145">
                  19.990
                </span>
              </div>
              <p className="text-xs text-gray-500" data-id="element-146">
                (pagas en la moneda de tu país)
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-2 text-left max-w-lg mx-auto mb-6" data-id="element-147">
              <div className="flex items-center gap-2" data-id="element-148">
                <Check className="w-5 h-5 text-green-500 shrink-0" data-id="element-149" />
                <span data-id="element-150">Acceso inmediato</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-151">
                <Check className="w-5 h-5 text-green-500 shrink-0" data-id="element-152" />
                <span data-id="element-153">Un solo pago</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-154">
                <Check className="w-5 h-5 text-green-500 shrink-0" data-id="element-155" />
                <span data-id="element-156">Descarga digital</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-157">
                <Check className="w-5 h-5 text-green-500 shrink-0" data-id="element-158" />
                <span data-id="element-159">Acceso de por vida</span>
              </div>
            </div>

            <CTAButton text="👉 QUIERO CREAR RECUERDOS REALES" subtext="Compra segura - Entrega inmediata" href="https://checkout.recursostop.shop/cart/45766342869188:1" data-id="element-160" />

            {/* Mercado Pago - Compra Segura */}
            <div className="mt-4 flex flex-col items-center gap-2" data-id="element-161">
              <img src="https://imgmp.mlstatic.com/org-img/banners/ar/medios/online/468X60.jpg" alt="Mercado Pago - Medios de pago" className="max-w-xs w-full rounded" data-id="element-162" />
              <div className="flex items-center gap-2 text-sm text-gray-500" data-id="element-163">
                <ShieldCheck className="w-4 h-4 text-blue-500" data-id="element-164" />
                <span data-id="element-165">
                  Compra protegida por{' '}
                  <strong className="text-blue-600" data-id="element-166">Mercado Pago</strong>
                </span>
              </div>
            </div>

            <div className="mt-6 pt-6 border-t border-gray-100" data-id="element-167">
              <div className="flex flex-col items-center gap-2" data-id="element-168">
                <ShieldCheck className="w-10 h-10 text-gray-400" data-id="element-169" />
                <div data-id="element-170">
                  <h4 className="font-bold text-gray-900" data-id="element-171">
                    🔒 Garantía sin riesgo
                  </h4>
                  <p className="text-gray-600 text-sm max-w-md mx-auto mt-2" data-id="element-172">
                    Probalo durante 7 días. Si sentís que no es para vos, te
                    devolvemos el 100% de tu dinero.
                    <br data-id="element-173" />
                    <span className="font-medium" data-id="element-174">
                      Sin preguntas. Sin culpa.
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}